/**
 * Which time field the office chose to edit on the end-of-day adjustment page.
 *
 * The employee break flow splits the meal break into a start and an end field;
 * both report as `MealBreak` so the value set stays aligned with the mobile
 * app and with the analytics spec.
 */
export enum EndOfDayAdjustmentType {
  Arrival = 'arrival',
  Departure = 'departure',
  MealBreak = 'meal_break',
}
